import { useState } from "react";
import axios from "axios";
import { getAccessToken } from "../utils/authSession";

const usePut = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const access_token = getAccessToken();
  const putData = async (putData, overrideUrl) => {
    setError(null);
    try {
      setLoading(true);
      const response = await axios.put(overrideUrl ?? url, putData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      // When the body is empty (e.g. 204), still set a truthy value so callers
      // can tell success apart from the initial null state.
      const payload =
        response?.data !== undefined && response?.data !== null
          ? response.data
          : {};
      setData(payload);
      return payload;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, putData };
};

export default usePut;
